import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider, GridDensityProvider, COLOR_PRIMARY } from '@project-scraper/shared';
import { router } from './router';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider primaryColor={COLOR_PRIMARY}>
      <GridDensityProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </GridDensityProvider>
    </ThemeProvider>
  </React.StrictMode>
);
